import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import PropertyMap from 'components/Common/PropertyMap/PropertyMap'
import { PROPERTY_MAP_MARKER_TYPE } from 'constants/map'

const VILLA_LOCATION_MAP_HEIGHT = 320
const VILLA_LOCATION_MAP_WRAPPER_STYLE = { height: VILLA_LOCATION_MAP_HEIGHT }
const MAP_LOAD_ROOT_MARGIN = '300px 0px'

const MapContainer = styled.div`
  height: ${VILLA_LOCATION_MAP_HEIGHT}px;
`

const MapPlaceholder = styled(LoadingBox)`
  width: 100%;
  height: 100%;
`

interface Props {
  offer: App.VillaOffer
}

function VillasPageLocationMeta({
  offer,
}: Props) {
  const intl = useIntl()
  const markers: Array<App.MapMarker> = useMemo(
    () => [{
      id: offer.property.id,
      type: PROPERTY_MAP_MARKER_TYPE,
      latitude: offer.property.latitude,
      longitude: offer.property.longitude,
    }],
    [offer],
  )
  const [mapInViewRef, hasMapBeenInView] = useInView({
    rootMargin: MAP_LOAD_ROOT_MARGIN,
    triggerOnce: true,
  })
  const mapContent = hasMapBeenInView ? (
    <PropertyMap
      markers={markers}
      height={VILLA_LOCATION_MAP_HEIGHT}
      wrapperStyle={VILLA_LOCATION_MAP_WRAPPER_STYLE}
    />
  ) : (
    <MapPlaceholder
      data-testid="villa-location-map-placeholder"
      borderRadius="S"
    />
  )

  return (
    <Group fullWidth direction="vertical" gap={32}>
      <Heading variant="heading2">
        {intl.formatMessage({
          id: 'lYPouxLRrq33sS8vuvee',
          defaultMessage: 'Location',
          description: 'Section title for villa property location on offer page',
        })}
      </Heading>
      {markers.length > 0 && (
        <Group direction="vertical" gap={20}>
          <MapContainer ref={mapInViewRef}>
            {mapContent}
          </MapContainer>
          {offer.property?.address && <BodyText variant="medium" weight="bold">
            {offer.property.address}
          </BodyText>}
        </Group>
      )}
    </Group>
  )
}

export default VillasPageLocationMeta
